import { render, staticRenderFns } from "./BaseCameraIcon.vue?vue&type=template&id=9738f49e"
import script from "./BaseCameraIcon.vue?vue&type=script&lang=js"
export * from "./BaseCameraIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports